var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExperienceIconcomponent = function SvgExperienceIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9c0-4.14 3.353-7.5 7.492-7.5C13.14 1.5 16.5 4.86 16.5 9c0 4.14-3.36 7.5-7.508 7.5C4.853 16.5 1.5 13.14 1.5 9Zm4.875-.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm5.25 0a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM9 15c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm-2.588-4.5C6.938 11.393 7.89 12 9 12s2.063-.607 2.588-1.5h1.252a4.121 4.121 0 0 1-7.68 0h1.252Z",
    fill: "#CECCC9"
  })));
};
export default SvgExperienceIconcomponent;